import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "w-6 h-4 flex items-center justify-center rounded-[4px] cursor-pointer",
    text: "font-semibold text-[0.70rem]"
  },
  variants: {
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white"
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white"
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-black"
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white"
      },
      gray: {
        bg: "bg-gray-400/30",
        text: "text-black"
      },
      orange: {
        bg: "bg-orange-500",
        text: "text-black"
      },
      lightGreen: {
        bg: "bg-green-400/30",
        text: "text-black"
      },
    }
  }
})();


/**
 * LegendIcon
 */

type Props = {
  color: 'red' | 'blue' | 'yellow' | 'green' | 'gray' | 'orange' | 'lightGreen',
  title: string,
};

export const LegendIcon = ({
  color,
  title,
}: Props) => {
  return (
    <div className={bg({ color })}>
      <h1 className={text({ color })}>{title}</h1>
    </div>
  );
}